var exports = {
  "kL": "x112a1f60--029a98--container",
  "DD": "x112a1f60--029a98--title",
  "Uq": "x112a1f60--029a98--value",
};

module.exports = exports;
